module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/655de9aaf44e424465bb2ac50c73b950.png";